import React, { Component } from "react";

class FetchProgressLoader extends Component {
    // Create a style element for the keyframes animation
    spinKeyframes = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `;

    render() {
        const { count, total, isLoading } = this.props;

        if (!isLoading) return null;

        return (
            <>
                <style>{this.spinKeyframes}</style>
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 9999,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            padding: "20px 40px",
                            borderRadius: "8px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        {/* Custom CSS Spinner */}
                        <div
                            style={{
                                border: "4px solid #f3f3f3",
                                borderTop: "4px solid #fe5722",
                                borderRadius: "50%",
                                width: "50px",
                                height: "50px",
                                animation: "spin 1s linear infinite",
                            }}
                        />

                        <h4
                            style={{
                                marginTop: "20px",
                                color: "#333",
                                fontWeight: "600",
                                marginBottom: 0,
                            }}
                        >
                            Fetching Customers...
                        </h4>
                        <p
                            style={{
                                marginTop: "10px",
                                color: "#666",
                                fontSize: "16px",
                                marginBottom: 0,
                            }}
                        >
                            Fetched: <strong>{count}</strong> {total > 0 ? `/ ${total}` : ""}
                        </p>
                        <p
                            style={{
                                marginTop: "5px",
                                color: "#888",
                                fontSize: "12px",
                                marginBottom: 0,
                            }}
                        >
                            Please wait, this may take a moment.
                        </p>
                    </div>
                </div>
            </>
        );
    }
}

export default FetchProgressLoader;